import React from 'react';
import { useParams } from 'react-router-dom';
import { KnowledgeContentComponent } from '../../../components/knowledge-content';
import { ROUTES } from 'shared/constants';
import { useGoBack } from 'src/hooks/use-go-back';
import { ContentPreviewProvider, useContentPreview } from '../knowledge-content/hooks';
import { NotFound } from '../../../components/common';
import { Loader } from '../../../components/core';

const KnowledgeHubContentInner = ({ id, onClose }) => {
  const { error, loading } = useContentPreview();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <NotFound />;
  }

  return <KnowledgeContentComponent id={id} close={onClose} />;
};

const KnowledgeHubContentPage = React.memo(() => {
  const { id } = useParams();
  const onClose = useGoBack(ROUTES.KNOWLEDGE_HUB);

  return (
    <ContentPreviewProvider isHub={true}>
      <KnowledgeHubContentInner id={id} onClose={onClose} />
    </ContentPreviewProvider>
  );
});

export { KnowledgeHubContentPage };
